/* eslint-disable react/no-multi-comp, react/display-name, react/prop-types */

import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import RemarkBreaks from 'remark-breaks'
import { Paragraph, Heading } from '@scentregroup/ui'
import { startsWith, deburr, get, kebabCase } from 'lodash'
import ResponsiveImage from '../responsive-image'
import Link from '../link'
import style from './index.scss'

const DEFAULT_MARKDOWN_IMAGE_WIDTH = 1200

// https://github.com/rexxars/react-markdown/blob/8ad8a995024a4729f066d109382b10c47d513379/src/renderers.js#L8
const Markdown = ({ content, dataTestId }) => (
  <ReactMarkdown
    skipHtml
    source={content}
    plugins={[RemarkBreaks]}
    className={style.Markdown}
    renderers={{
      root: ({ children }) => (
        <div className={style.Markdown} data-test-id={dataTestId}>
          {children}
        </div>
      ),
      link: ({ title, href, children }) =>
        startsWith(href, '#') ? (
          <a href={href} title={title}>
            {children}
          </a>
        ) : (
          <Link href={href} title={title}>
            {children}
          </Link>
        ),
      paragraph: ({ children }) => (
        <Paragraph type="large">{children}</Paragraph>
      ),
      heading: ({ level, children }) => (
        <Heading
          type={
            {
              1: 'large',
              2: 'medium',
              3: 'small',
            }[level] || 'extrasmall'
          }
          id={kebabCase(deburr(get(children, '[0].props.value', '')))}
        >
          {children}
        </Heading>
      ),
      image: ({ src, alt }) => (
        <ResponsiveImage
          lazyLoad
          desktopImageUrl={src}
          mobileImageUrl={src}
          width={DEFAULT_MARKDOWN_IMAGE_WIDTH}
          alt={alt}
        />
      ),
      tableCell: ({ isHeader, children }) =>
        isHeader ? (
          <th>
            <Heading type="extrasmall">{children}</Heading>
          </th>
        ) : (
          <td>{children}</td>
        ),
    }}
  />
)

Markdown.propTypes = {
  content: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
}

export default Markdown
